/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Resource } from '../../models/resource';

export interface GetImage$Params {

/**
 * The id (i.e path/name) of imported image to get the reference
 */
  key: string;
}

export function getImage(http: HttpClient, rootUrl: string, params: GetImage$Params, context?: HttpContext): Observable<StrictHttpResponse<Resource>> {
  const rb = new RequestBuilder(rootUrl, getImage.PATH, 'get');
  if (params) {
    rb.path('key', params.key, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Resource>;
    })
  );
}

getImage.PATH = '/import/images/{key}';
